import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactImageGalleryItem } from "react-image-gallery";
import { Anchors } from "../../constants/routes";
import siteImages from "../../data/siteImages";
import { AnimatedView } from "../utils/AnimatedView";
import ImagePreview from "../utils/ImagePreview";

const Showroom = () => {
  const { t } = useTranslation();
  const title = t("home.showroom.title");
  const description = t("home.showroom.description");

  const images: Array<ReactImageGalleryItem> = siteImages.showroomPhotos.map((item) => ({
    original: item.src,
    originalAlt: item.alt || title
  }));

  return (
    <Box id={Anchors.showroom}>
      <AnimatedView
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}>
        <Typography variant="h4" component="h2" fontWeight="bold" mb={{ xs: 6, md: 8 }}>
          {title}
        </Typography>
        <Typography variant="body2" mb={8}>
          {description}
        </Typography>
        <ImagePreview images={images} autoplay />
      </AnimatedView>
    </Box>
  );
};

export default Showroom;
